var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-title",on:{"click":_vm.handleClick}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],staticClass:"sp1",class:_vm.icon}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],staticClass:"sp2"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }